import { FC } from "react";
import useUser from "../helpers/useUser";

const VIPBanner: FC = () => {
  const [user] = useUser();

  if (!user || !user.subscription.allowed) return null;

  return (
    <div className={"vip-banner"}>
      <span>При наличии подписки действует скидка 50% на все картинки!</span>
    </div>
  );
};

export default VIPBanner;
